/**
 * useAppBridge Hook
 * Provides access to the global shopify App Bridge object
 */

import { useEffect, useState } from 'react';
import type { ShopifyAppBridge } from '../../types/shopify-app-bridge';

export function useAppBridge() {
  const [appBridge, setAppBridge] = useState<ShopifyAppBridge | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max wait

    const checkAppBridge = () => {
      if (window.shopify) {
        setAppBridge(window.shopify);
        setIsLoading(false);
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkAppBridge, 100);
      } else {
        // App Bridge failed to load after timeout - set loading false
        setIsLoading(false);
      }
    };

    checkAppBridge();
  }, []);

  return { appBridge, isLoading };
}
